/**
 * Utilities for URL manipulation
 */

/**
 * Formats the product description for use in URLs
 * @param {string} description - The product description
 * @returns {string} - The description formatted for URL
 */
export const formatDescriptionForUrl = (description) => {
  if (!description) return '';

  // Limits the description to a reasonable size for URL (first 100 characters)
  const limitedDescription = description.substring(0, 100);

  console.log('Formatando descrição para URL:', limitedDescription);

  // Removes special characters and replaces spaces with hyphens
  return limitedDescription
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Removes accents
    .replace(/[^\w\s-]/g, '') // Removes special characters
    .trim()
    .replace(/\s+/g, '-') // Replaces spaces with hyphens
    .toLowerCase();
};

/**
 * Generates a URL for the product details page including the description
 * @param {string} productId - The product ID
 * @param {string} description - The product description
 * @returns {string} - The formatted URL
 */
export const getProductUrlWithDescription = (productId, description) => {
  if (!productId) return '/';

  const formattedDescription = formatDescriptionForUrl(description);

  if (!formattedDescription) {
    return `/product/${productId}`;
  }

  return `/product/${productId}/${formattedDescription}`;
};
